<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader> Résumé de la journée </CCardHeader>

					<CCardBody>
						<vc-date-picker
							v-model="shippingDate"
							:model-config="modelConfig"
							:masks="masks"
							mode="date">
							<template v-slot="{ inputValue, inputEvents }">
								<div role="group" class="form-group">
									<label for="shipping-date">Choisissez une autre date</label>
									<div class="input-group">
										<input
											id="shipping-date"
											type="string"
											name="shippingDate"
											class="form-control"
											:value="inputValue"
											v-on="inputEvents" />
										<div class="input-group-append">
											<span class="input-group-text">
												<CIcon name="cil-calendar" />
											</span>
										</div>
										<small class="form-text text-muted w-100">Exemple: 06/12/2021</small>
									</div>
								</div>
							</template>
						</vc-date-picker>

						<h3>Résumé du {{ $moment(this.shippingDate).format('DD/MM/YYYY') }}</h3>
						<div class="table-responsive">
							<table class="table table-bordered col-sm-12 mt-3">
								<thead>
									<tr>
										<th scope="col">Statut</th>
										<th scope="col">Quantité</th>
										<th scope="col">Poids</th>
										<th scope="col">Volume</th>
										<th scope="col">Actions</th>
									</tr>
								</thead>
								<tbody>
									<template v-for="(state, i) in stateTotals">
										<tr :key="i">
											<td :class="{ 'col-1': true, 'row-total': isTotal(state.state) }">
												<CBadge :color="colorMapping[state.state]">{{
													stateMapping[state.state]
												}}</CBadge>
											</td>
											<td :class="{ 'col-1': true, 'row-total': isTotal(state.state) }">
												{{ state.quantity }}
											</td>
											<td :class="{ 'col-1': true, 'row-total': isTotal(state.state) }">
												{{ state.weight.toLocaleString() }}
											</td>
											<td :class="{ 'col-1': true, 'row-total': isTotal(state.state) }">
												{{ state.volume.toLocaleString() }}
											</td>
											<td
												:class="{
													'col-1': true,
													'row-total': isTotal(state.state),
													'text-center': true,
												}">
												<CButton
													color="primary"
													@click="openDetails(null, state.state)">
													<CIcon name="cil-folder-open"></CIcon>
													<span class="btn-text">Voir les colis</span>
												</CButton>
											</td>
										</tr>
									</template>
								</tbody>
							</table>
							<hr class="my-5" />
							<h3>Détails par type de colis</h3>
							<div class="table-responsive">
								<table class="table table-bordered col-sm-12 mt-3">
									<thead>
										<tr>
											<th scope="col">Nom</th>
											<th scope="col">Statut</th>
											<th scope="col">Quantité</th>
											<th scope="col">Poids</th>
											<th scope="col">Volume</th>
											<th scope="col">Actions</th>
										</tr>
									</thead>
									<tbody>
										<template v-for="(product, i) in products">
											<template v-for="(state, j) in product">
												<tr :key="i + ' ' + j">
													<template v-if="j === 0">
														<td :rowspan="product.length" class="col-2">
															{{ state.name }}
														</td>
													</template>
													<td
														:class="{
															'col-1': true,
															'row-total': isTotal(state.state),
														}">
														<CBadge :color="colorMapping[state.state]">{{
															stateMapping[state.state]
														}}</CBadge>
													</td>
													<td
														:class="{
															'col-1': true,
															'row-total': isTotal(state.state),
														}">
														{{ state.quantity }}
													</td>
													<td
														:class="{
															'col-1': true,
															'row-total': isTotal(state.state),
														}">
														{{ parseFloat(state.weight).toLocaleString() }}
													</td>
													<td
														:class="{
															'col-1': true,
															'row-total': isTotal(state.state),
														}">
														{{ parseFloat(state.volume).toLocaleString() }}
													</td>
													<td
														:class="{
															'col-1': true,
															'row-total': isTotal(state.state),
															'text-center': true,
														}">
														<CButton
															color="primary"
															@click="openDetails(state.id, state.state)">
															<CIcon name="cil-folder-open"></CIcon>
															<span class="btn-text">Voir les colis</span>
														</CButton>
													</td>
												</tr>
											</template>
										</template>
									</tbody>
								</table>
							</div>
						</div>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
		<PackagesDetailsModal ref="details" />
	</div>
</template>
<script>
	import PackagesDetailsModal from './PackagesDetailsModal';
	export default {
		components: { PackagesDetailsModal },
		data() {
			return {
				masks: {
					input: 'DD/MM/YYYY',
				},
				modelConfig: {
					type: 'string',
					mask: 'YYYY-MM-DD',
				},
				shippingDate: this.$moment().format('YYYY-MM-DD'),
				products: [],
				stateTotals: [],
				stateMapping: {
					'cart_product.pending': 'Étiquette non imprimée',
					'cart_product.label_printed': 'Étiquette imprimée',
					subtotal_labels: 'Total étiquettes',
					'cart_product.orphan': 'Colis retirés',
					'cart_product.scanned': 'Colis scanné',
					total: 'Total',
				},
				colorMapping: {
					'cart_product.pending': 'danger',
					'cart_product.label_printed': 'warning',
					subtotal_labels: 'info',
					'cart_product.orphan': 'warning',
					'cart_product.scanned': 'success',
					total: 'info',
				},
			};
		},
		watch: {
			shippingDate: function (newVal) {
				this.getProductionSummary();
			},
		},
		methods: {
			isTotal(state) {
				return state.includes('total');
			},
			getProductionSummary() {
				this.$axios
					.get(`/api/order_items/stats/${this.shippingDate}`)
					.then(res => {
						let productByState = {
							'cart_product.pending': [],
							'cart_product.label_printed': [],
							'cart_product.orphan': [],
							'cart_product.scanned': [],
							total: [],
						};

						// Calculate and store totals per product
						res.data.forEach(product => {
							const totals = this.getTotalForProduct(product);

							product.push({
								state: 'total',
								id: product[0].id,
								quantity: totals.quantity,
								weight: totals.weight,
								volume: totals.volume,
							});

							let allStates = [];
							product.forEach(state => {
								allStates.push(state.state);
								productByState[state.state].push(state);
							});

							// Add subtotal for labels
							if (
								allStates.includes('cart_product.pending') &&
								allStates.includes('cart_product.label_printed')
							) {
								product.splice(2, 0, {
									state: 'subtotal_labels',
									id: product[0].id,
									quantity:
										parseFloat(product[0].quantity) + parseFloat(product[1].quantity),
									weight: parseFloat(product[0].weight) + parseFloat(product[1].weight),
									volume: parseFloat(product[0].volume) + parseFloat(product[1].volume),
								});
							}
						});

						// Calculate and store totals per state
						let totalsPerState = [];
						for (let state in productByState) {
							const stateTotals = this.getTotalForProduct(productByState[state]);

							totalsPerState.push({
								state: state,
								quantity: stateTotals.quantity,
								weight: stateTotals.weight,
								volume: stateTotals.volume,
							});
						}

						// Add subtotal for labels
						totalsPerState.splice(2, 0, {
							state: 'subtotal_labels',
							quantity: totalsPerState[0].quantity + totalsPerState[1].quantity,
							weight: totalsPerState[0].weight + totalsPerState[1].weight,
							volume: totalsPerState[0].volume + totalsPerState[1].volume,
						});

						this.stateTotals = totalsPerState;

						this.products = res.data;
					})
					.catch(err => {
						this.$toast.error('Une erreur est survenue.');
					});
			},
			getTotalForProduct(product) {
				const totalWeight = product.reduce((acc, el) => {
					return acc + Number(el.weight);
				}, 0);
				const totalVolume = product.reduce((acc, el) => {
					return acc + Number(el.volume);
				}, 0);
				const totalQuantity = product.reduce((acc, el) => {
					return acc + Number(el.quantity);
				}, 0);

				return {
					weight: totalWeight,
					volume: totalVolume,
					quantity: totalQuantity,
				};
			},
			openDetails(productId, state) {
				let baseQuery = '/api/order_items?';
				let params = new URLSearchParams();

				params.set('shippingDate[after]', this.shippingDate);
				params.set('shippingDate[before]', this.shippingDate);
				params.append('cart.orders.status[]', 'order.paid');
				params.append('cart.orders.status[]', 'order.admin_authorized');

				if (productId !== null) {
					params.set('product', `/api/products/${productId}`);
				}

				if (state !== 'total' && state !== 'subtotal_labels') {
					params.set('state', state);
				}

				if (state === 'subtotal_labels') {
					params.append('state[]', 'cart_product.pending');
					params.append('state[]', 'cart_product.label_printed');
				}

				this.$refs.details.queryUrl = baseQuery + params.toString();
				this.$refs.details.showModal = true;
			},
		},
		mounted() {
			this.getProductionSummary();
		},
	};
</script>

<style>
	.table td {
		vertical-align: middle;
	}
	.row-total {
		background-color: #f2f2f3;
	}
	.btn-text {
		margin-left: 10px;
		vertical-align: middle;
	}
</style>
